import React from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { createEducationGroupAPI } from '../../../services/education'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'

function ModalAddAeEducation({
  showAE,
  setShowAE,
  dataAe,
  setDataAe,
  isSave,
  setIsSave,
  fnGetEducation,
  orgId,
  code
}) {
  const textError = 'Please, field your data'

  const onSubmit = async (d) => {
    setIsSave(true)
    createWorks()
  }
  const createWorks = async () => {
    try {
      const body = {
        orgId,
        code,
        educations: dataAe
      }
      const resp = await createEducationGroupAPI(body)
      if (!resp) return
      if (resp?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetEducation()
          setShowAE(false)
        })
      } else {
        Error_false(resp)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  const handleDateChange = (toDoList, id) => {
    setDataAe((prev) => {
      return prev.map((d) => (d.id === id ? { ...d, ...toDoList } : d))
    })
  }
  return (
    <ModalCustom width={850} open={showAE} onCancel={() => setShowAE(false)}>
      <h5>Number AE search results</h5>
      <Table responsive bordered hover className="mb-0">
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px' }}
        >
          <tr>
            <th className="fw-normal small" rowSpan={2}>
              Education Degree
            </th>
            <th className="fw-normal small" rowSpan={2}>
              Institution Name
            </th>
            <th className="fw-normal small text-center" colSpan={2}>
              Education Year
            </th>
            <th className="fw-normal small" rowSpan={2}>
              Educational Qualification
            </th>
            <th className="fw-normal small" rowSpan={2}>
              Faculty
            </th>
            <th className="fw-normal small" rowSpan={2}>
              Major
            </th>{' '}
            
            <th className="fw-normal small" rowSpan={2}>
              Grade
            </th>
          </tr>
          <tr>
            <th className="fw-normal small text-center">From</th>
            <th className="fw-normal small text-center">To</th>
          </tr>
        </thead>
        <tbody>
          {dataAe.length > 0 ? (
            dataAe.map((d, i) => (
              <tr key={i} className="fw-light font-small-2 ">
                <td>
                  {d.isEducationLevel ? (
                    <> {d.education_level}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.education_level}
                        onChange={(e) => {
                          handleDateChange(
                            { education_level: e.target.value },
                            d.id
                          )
                        }}
                      />
                      {!d.education_level ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td>
                  {d.isEduName ? (
                    <> {d.eduName}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.eduName}
                        onChange={(e) => {
                          handleDateChange({ eduName: e.target.value }, d.id)
                        }}
                      />
                      {!d.eduName ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                <td className="text-center">
                  {d.isAdYear ? (
                    <> {d.adYear}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.adYear}
                        onChange={(e) => {
                          handleDateChange({ adYear: e.target.value }, d.id)
                        }}
                      />
                      {!d.adYear ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
               
                <td className="text-center">
                  {d.isGradYear ? (
                    <> {d.gradYear}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.gradYear}
                        onChange={(e) => {
                          handleDateChange({ gradYear: e.target.value }, d.id)
                        }}
                      />
                      {!d.gradYear ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
               {/* qualification */}
                <td>
                  {d.isEduBg ? (
                    <> {d.eduBg}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.faculty}
                        onChange={(e) => {
                          handleDateChange({ qualification: e.target.value }, d.id)
                        }}
                      />
                      {!d.eduBg ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                {/* facculty */}
                <td>
                  {d.isQualification ? (
                    <> {d.qualification}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.qualification}
                        onChange={(e) => {
                          handleDateChange(
                            { eduBg: e.target.value },
                            d.id
                          )
                        }}
                      />
                      {!d.qualification ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                {/* major */}
                <td>
                  {d.isMajor ? (
                    <> {d.major}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.major}
                        onChange={(e) => {
                          handleDateChange({ major: e.target.value }, d.id)
                        }}
                      />
                      {!d.major ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
                
                <td>
                  {d.isGrade ? (
                    <> {d.grade}</>
                  ) : (
                    <>
                      <Form.Control
                        maxLength={300}
                        value={d?.grade}
                        onChange={(e) => {
                          handleDateChange({ grade: e.target.value }, d.id)
                        }}
                      />
                      {!d.grade ? (
                        <div className="text-danger">{textError}</div>
                      ) : null}
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr className="fw-light ">
              <td colSpan={10} className="text-center">
                - No data -
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Row className="mt-3">
        <Col xl={12} className="text-center">
          <Button
            className="px-4 text-primary me-3"
            onClick={() => setShowAE(false)}
            variant="light"
            size="sm"
          >
            Cancel
          </Button>
          {dataAe.length > 0 ? (
            <Button
              className="px-4"
              disabled={isSave}
              onClick={onSubmit}
              size="sm"
            >
              {isSave ? 'Adding...' : 'Add All'}
            </Button>
          ) : (
            <Button className="px-4" disabled={true} size="sm">
              Add All
            </Button>
          )}
        </Col>
      </Row>
    </ModalCustom>
  )
}

export default ModalAddAeEducation
